<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="d_flex_btwn">
        <h1 class="common_title">All Tickets</h1>
        <div>
          <!--                  <router-link class="btn btn_primary mr_10" :to="{name: 'ticket-import'}">Import Ticket (CSV)</router-link>-->
          <button class="btn btn_primary mr_10" @click="exportTickets">
            Export Ticket (CSV)
          </button>
          <router-link class="btn btn_black mr_10" :to="{ name: 'create-ticket' }"
            >+ Add a New Ticket</router-link
          >
          <button
            type="button"
            class="btn btn_black"
            title="Table columns"
            @click="showColumnSettings = true"
          >
            Settings
          </button>
        </div>
      </div>
      <div class="ticket_list_header">
        <div class="d_flex_btwn">
          <!--          <div class="form_checkbox d_flex_start">
            <input
              type="checkbox"
              id="checkAll"
              v-model="isCheckAll"
              :value="0"
            />
            <label
              for="checkAll"
              class="text_nowrap pr_0"
              @click.prevent="checkAll()"
            ></label>
          </div>-->
          <div class="d_flex_start" v-if="showMultipleAction">
            <button
              type="button"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
              @click.prevent="doCombineAction('delete')"
            >
              <span class="mr_5 d_flex_center">
                <svg
                  width="18px"
                  height="18px"
                  viewBox="0 -0.5 21 21"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <title>delete [#1487]</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Dribbble-Light-Preview"
                        transform="translate(-179.000000, -360.000000)"
                        fill="#000000"
                      >
                        <g
                          id="icons"
                          transform="translate(56.000000, 160.000000)"
                        >
                          <path
                            d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                            id="delete-[#1487]"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <span>Delete</span>
            </button>
          </div>
          <template v-else>
            <div class="form_row_inline mb_0">
              <label class="width_85p"> Sort by:</label>
              <div class="form_input">
                <select class="form_global ml_5 width_260p" v-model="sort">
                  <option value="1">Date created (Ascending)</option>
                  <option value="2">Date created (Descending)</option>
                  <option value="3">Date modified (Ascending)</option>
                  <option value="4">Date modified (Descending)</option>
                </select>
              </div>
            </div>
            <div class="form_row_inline mb_0">
              <div class="form_input">
                <select
                  class="form_global ml_5 width_120p"
                  v-model="filter.filter_status"
                  @change="
                    queryParams.page = 1;
                    changeRoute();
                  "
                >
                  <option value="">Status All</option>
                  <option value="open">Open</option>
                  <option value="pending">Pending</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
            </div>
            <div class="form_row_inline mb_0">
              <div class="form_input">
                <select
                  class="form_global ml_5 width_120p"
                  v-model="filter.priority"
                  @change="
                    queryParams.page = 1;
                    changeRoute();
                  "
                >
                  <option value="">Priority All</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>
            </div>
            <div class="form_row_inline mb_0">
              <div class="form_input">
                <select
                  class="form_global ml_5 width_140p"
                  v-model="filter.support_request_type_id"
                  @change="
                    queryParams.page = 1;
                    changeRoute();
                  "
                >
                  <option value="">Request Type All</option>
                  <option
                    v-for="requestType in requestTypes"
                    :value="requestType.id"
                    :key="requestType.id"
                  >
                    {{ requestType.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form_row_inline mb_0">
              <div class="form_input">
                <select
                  class="form_global ml_5 width_120p"
                  v-model="filter.group_id"
                  @change="
                    queryParams.page = 1;
                    changeRoute();
                  "
                >
                  <option value="">Group All</option>
                  <option
                    v-for="group in groups"
                    :value="group.id"
                    :key="group.id"
                  >
                    {{ group.name }}
                  </option>
                </select>
              </div>
            </div>
          </template>

          <div class="order_filter_content">
            <div class="d_flex_start">
              <input
                type="text"
                class="form_global mr_5"
                placeholder="Search"
                v-model="queryParams.search"
              />
              <button
                class="btn btn_black mr_5 width_100p pt_10 pb_10"
                @click="searchQuery()"
              >
                Search
              </button>
              <button
                class="btn btn_black width_100p pt_10 pb_10 mr_10"
                @click="resetAll()"
              >
                Reset
              </button>

              <select
                name=""
                class="form_global width_150p"
                v-model="filter.per_page"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
          </div>
          <div class="d_flex_end">
            <top-pagination-component
              :pagination="pagination"
              @pageChanged="pageChanged"
            >
              <template v-slot:table_collapse>
                <div class="collapse_ticket">
                  <button class="btn btn_transparent has_border_radius p_5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 32 32"
                      class="app-icon app-icon--small icon-detail-right"
                    >
                      <path
                        d="M20.038 4.29H4.895a.606.606 0 00-.606.606v22.21c0 .335.271.606.606.606h15.143V4.291zm2.423 0v23.421h4.644a.606.606 0 00.606-.606V4.895a.606.606 0 00-.606-.606h-4.644zM4.895 1.867h22.21a3.029 3.029 0 013.029 3.029v22.21a3.029 3.029 0 01-3.029 3.029H4.895a3.029 3.029 0 01-3.029-3.029V4.896a3.029 3.029 0 013.029-3.029zM13.479 16l-4.191-4.191a1.211 1.211 0 011.713-1.713l5.048 5.048c.473.473.473 1.24 0 1.713l-5.048 5.048a1.211 1.211 0 01-1.713-1.713l4.191-4.191z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </template>
            </top-pagination-component>
          </div>
        </div>
      </div>
      <div class="vlan_ticket_list_page">
        <div class="vlan_ticket_list_page_wrap no_right_filter">
          <div class="vlan_ticket_list_left">
            <div class="vlan_ticket_list_left_wrap">
              <ticket-table-component
                :columns="columns"
                :rows="tickets"
                :sortable="sortable"
                :pagination="pagination"
                @sorting="sorting"
                @pageChanged="pageChanged"
              >
                <template v-slot:id="{ row }">
                  <div class="form_checkbox d_flex_start">
                    <input
                      type="checkbox"
                      :id="'action_' + row.id"
                      :checked="checkedTickets.includes(row.id)"
                      :value="row.id"
                    />
                    <label
                      :for="'action_' + row.id"
                      class="text_nowrap pr_0"
                      @click.prevent="checkSingleTicket(row.id)"
                    ></label>
                  </div>
                </template>

                <template v-slot:company="{ row }">
                  <router-link
                    class="cursor_pointer color_green"
                    :to="`/company/${row?.company_id}/show`"
                    >{{ row?.company?.company_name }}</router-link
                  >
                </template>

                <template v-slot:contact="{ row }">
                  <template v-if="row?.contact || row?.customer_email">
                    <div>{{ row?.contact?.name ?? row?.customer_name }}</div>
                    <div class="color_grey" style="font-size: 12px">
                      {{ row?.contact?.email ?? row?.customer_email }}
                    </div>
                  </template>
                </template>

                <template v-slot:ticket_number="{ row }">
                  <router-link
                    class="cursor_pointer color_green"
                    :to="`/ticket/${row.ticket_number}`"
                    >{{ row.ticket_number }}</router-link
                  >
                </template>

                <template v-slot:subject="{ row }">
                  <router-link
                    class="color_green"
                    :to="`/ticket/${row.ticket_number}`"
                  >
                    {{ row.formatted_subject }}
                  </router-link>
                </template>

                <template v-slot:status="{ row }">
                  <Multiselect
                    :ref="`statusSelectRef${row.id}`"
                    v-model="row.status"
                    :options="statuses"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a status"
                    track-by="label"
                    :optionHeight="20"
                    :custom-label="statusLabel"
                    :disabled="isDropdownDisabled"
                    @Select="
                      (selectedStatus) =>
                        updateStatusExtraParam(
                          row.id,
                          selectedStatus,
                          `statusSelectRef${row.id}`
                        )
                    "
                  />
                </template>

                <template v-slot:priority="{ row }">
                  <Multiselect
                    :ref="`prioritySelectRef${row.id}`"
                    v-model="row.priority"
                    :options="priorities"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a priority"
                    track-by="label"
                    :optionHeight="20"
                    :custom-label="priorityLabel"
                    :disabled="true"
                    @Select="
                      (selectedPriority) =>
                        updatePriorityExtraParam(
                          row.id,
                          selectedPriority,
                          `prioritySelectRef${row.id}`
                        )
                    "
                  />
                </template>

                <template v-slot:group_id="{ row }">
                  <Multiselect
                    :ref="`groupSelectRef${row.id}`"
                    v-model="row.group_id"
                    :options="groups"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a group"
                    track-by="id"
                    :optionHeight="20"
                    :custom-label="groupLabel"
                    @Select="
                      (selectedGroup) =>
                        updateGroupExtraParam(
                          row.id,
                          selectedGroup,
                          `groupSelectRef${row.id}`
                        )
                    "
                    :disabled="true"
                  />
                </template>

                <template v-slot:support_request_type_id="{ row }">
                  <Multiselect
                    :ref="`requestTypeSelectRef${row.id}`"
                    v-model="row.support_request_type_id"
                    :options="requestTypes"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a request type"
                    track-by="id"
                    :optionHeight="20"
                    :custom-label="requestTypeLabel"
                    @Select="
                      (selectedRequestType) =>
                        updateRequestTypeExtraParam(
                          row.id,
                          selectedRequestType,
                          `requestTypeSelectRef${row.id}`
                        )
                    "
                    :disabled="true"
                  />
                </template>

                <template v-slot:user_id="{ row }">
                  <Multiselect
                    :ref="`userSelectRef${row.id}`"
                    v-model="row.users"
                    :options="users"
                    :multiple="true"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a user"
                    track-by="id"
                    :optionHeight="20"
                    :custom-label="userLabel"
                    @Select="
                      (selectedUser) =>
                        updateUserExtraParam(
                          row.id,
                          row.users,
                          `userSelectRef${row.id}`
                        )
                    "
                    :disabled="true"
                  />
                </template>

                <template v-slot:action="{ row }">
                  <router-link :to="`/ticket/${row.ticket_number}`">
                    <span title="Details"
                      ><img src="@/assets/media/images/search2.png" alt=""
                    /></span>
                  </router-link>
                  <span
                    title="Delete"
                    class="pl_15 cursor_pointer"
                    @click.prevent="deleteRecord(row)"
                    ><img src="@/assets/media/images/trash.png" alt=""
                  /></span>
                </template>
              </ticket-table-component>
            </div>
          </div>
          <div class="vlan_ticket_list_right">
            <div class="ticket_list_filter">
              <h2 class="ticket_list_title d_flex_btwn">
                <span>FILTERS</span>
                <!-- <span class="ticket_list_search_toggler cursor_pointer"><i class="lni lni-search-alt"></i></span> -->
              </h2>

              <div class="ticket_list_filter_inner">
                <div
                  class="form_row ticket_list_search_toggler_content"
                  style="display: none"
                >
                  <div class="form_input">
                    <div class="search_input">
                      <input
                        type="text"
                        class="form_global"
                        placeholder="Search"
                      />
                    </div>
                  </div>
                </div>
                <div class="form_row">
                  <label> Request Type Include </label>
                  <Multiselect
                    v-model="selectedRequestType"
                    :options="requestTypes"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a request type"
                    label="name"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onRequestTypeSelect"
                    @remove="onRequestTypeRemove"
                  />
                </div>
                <div class="form_row">
                  <label> Group Include </label>
                  <Multiselect
                    v-model="selectedGroup"
                    :options="groups"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a group"
                    label="name"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onGroupSelect"
                    @remove="onGroupRemove"
                  />
                </div>
                <div v-if="user?.user_role === 'Admin'" class="form_row">
                  <label> User Include </label>
                  <Multiselect
                    v-model="selectedUser"
                    :options="users"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a user"
                    label="name"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onUserSelect"
                    @remove="onUserRemove"
                  />
                </div>
                <div class="form_row">
                  <label> Updated </label>
                  <div class="form_input">
                    <select class="form_global" v-model="filter.period">
                      <option value="">All Time</option>
                      <option value="0">Input Period</option>
                      <option value="1">Today</option>
                      <option value="2">This Week</option>
                      <option value="3">This Month</option>
                      <option value="5">This Year</option>
                      <option value="6">Yesterday</option>
                      <option value="8">Last Month</option>
                      <option value="10">Last Year</option>
                      <option value="13">Last 7 Days</option>
                      <option value="14">Last 30 Days</option>
                      <option value="15">Last 90 Days</option>
                      <option value="16">Last 365 Days</option>
                    </select>
                  </div>
                </div>
                <div class="form_row" v-if="filter.period == '0'">
                  <label> Created date range </label>
                  <div class="form_input">
                    <date-picker
                      v-model:input="filter.start_date"
                    ></date-picker>
                    <div :class="['mr_5 ml_5 mt_10 text_center']">to</div>
                    <date-picker v-model:input="filter.end_date"></date-picker>
                  </div>
                </div>
                <div class="form_row">
                  <label> Status Include </label>
                  <Multiselect
                    v-model="selectedStatus"
                    :options="statuses"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a status"
                    label="name"
                    track-by="label"
                    :optionHeight="20"
                    @Select="onStatusSelect"
                    @remove="onStatusRemove"
                  />
                </div>
                <div class="form_row">
                  <label> Priority Include </label>
                  <Multiselect
                    v-model="selectedPriority"
                    :options="priorities"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a priority"
                    label="name"
                    track-by="label"
                    :optionHeight="20"
                    @Select="onPrioritySelect"
                    @remove="onPriorityRemove"
                  />
                </div>
                <div class="form_row">
                  <label> Company Include </label>
                  <Multiselect
                    v-model="selectedCompany"
                    :options="companies"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a company"
                    label="company_name"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onCompanySelect"
                    @remove="onCompanyRemove"
                  />
                </div>
                <div class="form_row">
                  <label> Contact Include </label>
                  <Multiselect
                    v-model="selectedContact"
                    :options="contacts"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a contact"
                    label="name"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onContactSelect"
                    @remove="onContactRemove"
                  />
                </div>
              </div>
              <span>
                <button
                  type="button"
                  class="btn btn_black has_border_radius width_200p mr_5"
                  @click="searchQuery()"
                >
                  Apply
                </button>
                <button
                  type="button"
                  class="btn btn_primary has_border_radius width_100p"
                  @click="resetAll()"
                >
                  Reset
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Outside the v-else so it survives the loader that a save-triggered
         reload would otherwise swap in underneath it. -->
    <TicketColumnSettingsModal
      v-if="showColumnSettings"
      :columns="configuredColumns"
      :default-columns="defaultConfigurableColumns"
      :saving="savingColumnSettings"
      @save="saveColumnSettings"
      @close="showColumnSettings = false"
    />
  </div>
</template>

<script>
import TicketTableComponent from '@/components/shared/TicketTableComponent';
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TopPaginationComponent from '@/components/shared/TopPaginationComponent.vue';
import Multiselect from 'vue-multiselect';
// this.axios is an axios.create() instance, which does not carry the static
// CancelToken/isCancel members — take those from the package itself.
import rawAxios from 'axios';
import DatePicker from '@/components/shared/DatePicker';
import TicketColumnSettingsModal from '@/components/tickets/TicketColumnSettingsModal';
import { mapGetters } from 'vuex';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';

// Hoisted so data(), setQueryData() and resetAll() share one definition of
// "no filters applied" — a bare /tickets must look identical however it was
// reached (fresh load, deep link, or the sidebar link, which carries no query).
const defaultQueryParams = () => ({
  page: 1,
  search: '',
  search_columns:
    'company.company_name,contact.name,ticket_number,subject,status',
  sort: 'created_at',
  sort_order: 'desc',
  per_page: 20,
});

// Every column the list can render, in default order. `locked` columns are not
// configurable: the row checkbox is always leftmost and Action always rightmost,
// so a saved layout can never strand the row actions. Everything else is
// hidden/shown and reordered from the Settings modal, and the shape of each
// entry is what TicketTableComponent consumes.
//
// Keep the configurable `field` values in sync with TICKET_COLUMN_FIELDS in
// api/app/Http/Controllers/Admin/SettingController.php, which validates them.
const COLUMN_CATALOGUE = [
  { label: '', field: 'id', sortable: false, slot: true, width: '5%', locked: 'first' },
  { label: 'Ticket number', field: 'ticket_number', sortable: true, slot: true, width: '10%', defaultVisible: true },
  { label: 'Subject', field: 'subject', sortable: false, slot: true, width: 'auto', defaultVisible: true },
  { label: 'Company', field: 'company', sortable: false, slot: true, width: 'auto', defaultVisible: true },
  { label: 'Name', field: 'contact', sortable: false, slot: true, width: 'auto', defaultVisible: false },
  { label: 'Status', field: 'status', sortable: false, slot: true, width: 'auto', defaultVisible: true },
  { label: 'Priority', field: 'priority', sortable: false, slot: true, width: 'auto', defaultVisible: false },
  { label: 'Group', field: 'group_id', sortable: false, slot: true, width: 'auto', defaultVisible: false },
  { label: 'Request Type', field: 'support_request_type_id', sortable: false, slot: true, width: 'auto', defaultVisible: true },
  { label: 'User', field: 'user_id', sortable: false, slot: true, width: '12%', defaultVisible: true },
  { label: 'Modified At', field: 'updated_at', sortable: true, width: '10%', defaultVisible: true },
  // No slot: TicketTableComponent's text fallback renders row.created_at, which
  // the API already sends preformatted.
  { label: 'Created At', field: 'created_at', sortable: true, width: '10%', defaultVisible: true },
  { label: 'Action', field: 'action', sortable: false, slot: true, width: '5%', locked: 'last' },
];

const configurableColumns = () => COLUMN_CATALOGUE.filter((column) => !column.locked);

const defaultFilter = () => ({
  group_id: '',
  support_request_type_id: '',
  user_id: '',
  status: '',
  priority: '',
  company_id: '',
  contact_id: '',
  filter_status: '',
  period: '',
  start_date: '',
  end_date: '',
  per_page: 20,
});

export default {
  name: 'tickets',
  components: {
    LoaderMaskComponent,
    TicketTableComponent,
    TopPaginationComponent,
    Multiselect,
    DatePicker,
    TicketColumnSettingsModal,
  },
  data() {
    return {
      lyLoading: false,
      statuses: [
        {
          label: 'open',
          name: 'Open',
        },
        {
          label: 'pending',
          name: 'Pending',
        },
        {
          label: 'resolved',
          name: 'Resolved',
        },
        {
          label: 'closed',
          name: 'Closed',
        },
      ],
      priorities: [
        {
          label: 'low',
          name: 'Low',
        },
        {
          label: 'medium',
          name: 'Medium',
        },
        {
          label: 'high',
          name: 'High',
        },
        {
          label: 'urgent',
          name: 'Urgent',
        },
      ],
      tickets: [],
      filter: defaultFilter(),
      queryParams: defaultQueryParams(),
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      sort: '2',
      // [{field, visible}] saved on the server; null until it loads (or when it
      // never has), which means "use the catalogue defaults".
      columnConfig: null,
      showColumnSettings: false,
      savingColumnSettings: false,
      pagination: null,
      groups: [],
      requestTypes: [],
      users: [],
      companies: [],
      contacts: [],
      selectedGroup: null,
      selectedRequestType: null,
      selectedUser: null,
      selectedStatus: null,
      selectedPriority: null,
      selectedCompany: null,
      selectedContact: null,
      showMultipleAction: false,
      isCheckAll: false,
      checkedTickets: [],
      isDropdownDisabled: false,
      ticketRequestSource: null,
      syncingSort: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
    // The saved layout resolved against the catalogue: saved order first, then
    // any catalogue column the saved layout predates, appended in catalogue
    // position with its default visibility. Fields no longer in the catalogue
    // are dropped. Falls back to the catalogue defaults while unloaded.
    configuredColumns() {
      const catalogue = configurableColumns();

      if (!Array.isArray(this.columnConfig)) {
        return catalogue.map((column) => ({
          field: column.field,
          label: column.label,
          visible: column.defaultVisible,
        }));
      }

      const saved = this.columnConfig
        .map((entry) => {
          const column = catalogue.find((item) => item.field === entry.field);

          return column
            ? { field: column.field, label: column.label, visible: !!entry.visible }
            : null;
        })
        .filter(Boolean);

      catalogue.forEach((column, index) => {
        if (saved.some((entry) => entry.field === column.field)) return;

        saved.splice(index, 0, {
          field: column.field,
          label: column.label,
          visible: column.defaultVisible,
        });
      });

      return saved;
    },
    // What TicketTableComponent renders: locked checkbox column, the visible
    // configured columns in their saved order, locked Action column.
    columns() {
      const byField = (field) =>
        COLUMN_CATALOGUE.find((column) => column.field === field);

      return [
        byField('id'),
        ...this.configuredColumns
          .filter((entry) => entry.visible)
          .map((entry) => byField(entry.field)),
        byField('action'),
      ];
    },
    defaultConfigurableColumns() {
      return configurableColumns().map((column) => ({
        field: column.field,
        label: column.label,
        visible: column.defaultVisible,
      }));
    },
  },
  created() {
    // No query seeding or loadData() here: the immediate '$route.query' watcher
    // fires before this hook and applyFilters() owns both.
    this.loadColumnSettings();
    this.getGroups();
    this.getRequestTypes();
    this.getUsers();
    this.getContacts();
    this.getCompanies();
  },
  mounted() {
    this.ticketingEmailTableScroll();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    // Registered by ticketingEmailTableScroll(); each visit would otherwise
    // leave a layout-forcing listener behind for the SPA's lifetime.
    window.removeEventListener('resize', this.getEmailTicketListHeight);
    if (this.ticketRequestSource) {
      this.ticketRequestSource.cancel('component destroyed');
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        // No setQueryData()/loadData() here: applyFilters(), driven by the
        // '$route.query' watcher, owns all state seeding and the fetch.
        this.ticketingEmailTableScroll();
      }
    },
    sort() {
      // applyFilters() writes this back from the URL; without the guard that
      // assignment would re-enter sorting() and push a redundant navigation.
      if (this.syncingSort) return;

      if (this.sort === '1') {
        this.sorting({ column: 'created_at', order: 'asc' });
      } else if (this.sort === '2') {
        this.sorting({ column: 'created_at', order: 'desc' });
      } else if (this.sort === '3') {
        this.sorting({ column: 'updated_at', order: 'asc' });
      } else if (this.sort === '4') {
        this.sorting({ column: 'updated_at', order: 'desc' });
      }
    },
    '$route.query': {
      handler() {
        this.applyFilters();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    applyFilters() {
      const query = this.$route.query;

      // The URL is the single source of truth: state is the defaults with the
      // URL overlaid, so a query that drops a param (the sidebar link pushes a
      // bare /tickets) falls back to the default instead of to undefined.
      this.setQueryData(query);
      this.syncSelectedFromQuery(query);
      this.syncSortSelect();

      this.loadData();
    },
    // The multiselect chips mirror the URL. The list endpoints repeat these
    // lookups when they resolve, which covers the first load, where the lists
    // are still in flight.
    syncSelectedFromQuery(query) {
      const findById = (list, id) =>
        id ? list.find((item) => item.id == id) || null : null;

      this.selectedGroup = findById(this.groups, query.group_id);
      this.selectedRequestType = findById(
        this.requestTypes,
        query.support_request_type_id
      );
      this.selectedUser = findById(this.users, query.user_id);
      this.selectedCompany = findById(this.companies, query.company_id);
      this.selectedContact = findById(this.contacts, query.contact_id);

      // One control backs both 'status' and 'filter_status'.
      const statusLabel = query.status || query.filter_status;
      this.selectedStatus = statusLabel
        ? this.statuses.find((s) => s.label == statusLabel) || null
        : null;

      this.selectedPriority = query.priority
        ? this.priorities.find((p) => p.label == query.priority) || null
        : null;
    },
    syncSortSelect() {
      const options = {
        created_at: { asc: '1', desc: '2' },
        updated_at: { asc: '3', desc: '4' },
      };
      const value = (options[this.queryParams.sort] || {})[
        this.queryParams.sort_order
      ];

      if (!value || value === this.sort) return;

      // Guarded: the watcher would otherwise treat this as a user pick and
      // push a redundant navigation.
      this.syncingSort = true;
      this.sort = value;
      this.$nextTick(() => {
        this.syncingSort = false;
      });
    },
    getSelectedUsers(row) {
      let userids = row.users.map((user) => user.id);
      return userids;
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.checkedTickets = [];
      if (this.isCheckAll) {
        this.showMultipleAction = true;
        for (var key in this.tickets) {
          this.checkedTickets.push(this.tickets[key].id);
        }
      } else {
        this.showMultipleAction = false;
      }
    },
    checkSingleTicket(id) {
      let index = window._.findIndex(
        this.checkedTickets,
        (checkedTicketId) => checkedTicketId == id
      );
      if (index > -1) {
        this.checkedTickets.splice(index, 1);
      } else {
        this.checkedTickets.push(id);
      }

      if (this.checkedTickets.length > 0) {
        this.showMultipleAction = true;
      } else {
        this.showMultipleAction = false;
      }
      this.isCheckAll = false;
    },
    getGroups() {
      this.axios.get('/active-groups-for-relation').then(({ data }) => {
        this.groups = data.data;
        if (this.$route.query.group_id) {
          var group = this.groups.filter(
            (group) => group.id == this.$route.query.group_id
          );
          if (group && group.length > 0) {
            this.selectedGroup = group[0];
          }
        }
      });
    },
    getRequestTypes() {
      this.axios.get('/active-support-request-types').then(({ data }) => {
        this.requestTypes = data.data;
        if (this.$route.query.support_request_type_id) {
          var requestType = this.requestTypes.filter(
            (group) => group.id == this.$route.query.support_request_type_id
          );
          if (requestType && requestType.length > 0) {
            this.selectedRequestType = requestType[0];
          }
        }
      });
    },
    getUsers() {
      this.axios.get('/active-users-for-relation').then(({ data }) => {
        this.users = data.data;
        if (this.$route.query.user_id) {
          var user = this.users.filter(
            (user) => user.id == this.$route.query.user_id
          );
          if (user && user.length > 0) {
            this.selectedUser = user[0];
          }
        }
      });
    },
    getCompanies() {
      // The company filter only needs names; skip the nested contacts, which
      // duplicate the payload of /active-contacts-for-relation below.
      this.axios
        .get('/active-companies-for-relation', {
          params: { exclude_contacts: 1 },
        })
        .then(({ data }) => {
          this.companies = data.data;
          if (this.$route.query.company_id) {
            var company = this.companies.filter(
              (company) => company.id == this.$route.query.company_id
            );
            if (company && company.length > 0) {
              this.selectedCompany = company[0];
            }
          }
        });
    },
    getContacts() {
      this.axios.get('/active-contacts-for-relation').then(({ data }) => {
        this.contacts = data.data;
        if (this.$route.query.contact_id) {
          var contact = this.contacts.filter(
            (contact) => contact.id == this.$route.query.contact_id
          );
          if (contact && contact.length > 0) {
            this.selectedContact = contact[0];
          }
        }
      });
    },
    statusLabel(option) {
      const status = this.statuses.find((status) => status.label === option);
      return status ? status.name : option.name;
    },
    updateStatusExtraParam(rowId, selectedStatus, refKey) {
      this.isDropdownDisabled = true;
      this.$refs[refKey].deactivate();
      this.$swal({
        title: 'Are you sure want to update status?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/status/' + rowId, { status: selectedStatus.label })
            .then(() => {
              this.loadData();
              this.showSuccessMsg('Updated Successfully!');
            });
        }
        this.$nextTick(() => {
          this.isDropdownDisabled = false;
          this.$refs[refKey].deactivate();
        });
      });
    },
    priorityLabel(option) {
      const priority = this.priorities.find(
        (priority) => priority.label === option
      );
      return priority ? priority.name : option.name;
    },
    updatePriorityExtraParam(rowId, selectedPriority, refKey) {
      this.isDropdownDisabled = true;
      this.$refs[refKey].deactivate();

      this.$swal({
        title: 'Are you sure want to update priority?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/priority/' + rowId, {
              priority: selectedPriority.label,
            })
            .then(() => {
              this.showSuccessMsg('Updated Successfully!');
            });
        }
        this.$nextTick(() => {
          this.isDropdownDisabled = false;
          this.$refs[refKey].deactivate();
        });
      });
    },
    groupLabel(option) {
      const group = this.groups.find((group) => group.id === option);
      return group ? group.name : option.name;
    },
    updateGroupExtraParam(rowId, selectedGroup, refKey) {
      this.isDropdownDisabled = true;
      this.$refs[refKey].deactivate();

      this.$swal({
        title: 'Are you sure want to update group?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/group/' + rowId, { group_id: selectedGroup.id })
            .then(() => {
              this.showSuccessMsg('Updated Successfully!');
            });
        }

        this.$nextTick(() => {
          this.isDropdownDisabled = false;
          this.$refs[refKey].deactivate();
        });
      });
    },
    requestTypeLabel(option) {
      const requestType = this.requestTypes.find(
        (requestType) => requestType.id === option
      );
      return requestType ? requestType.name : option.name;
    },
    updateRequestTypeExtraParam(rowId, selectedRequestType, refKey) {
      this.isDropdownDisabled = true;
      this.$refs[refKey].deactivate();

      this.$swal({
        title: 'Are you sure want to update request type?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/support-request-type/' + rowId, {
              support_request_type_id: selectedRequestType.id,
            })
            .then(() => {
              this.showSuccessMsg('Updated Successfully!');
            });
        }
        this.$nextTick(() => {
          this.isDropdownDisabled = false;
          this.$refs[refKey].deactivate();
        });
      });
    },
    userLabel(option) {
      const user = this.users.find((user) => user.id === option);
      return user ? user.name : option.name;
    },
    updateUserExtraParam(rowId, selectedUser, refKey) {
      this.isDropdownDisabled = true;
      this.$refs[refKey].deactivate();

      this.$swal({
        title: 'Are you sure want to update user?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/user/' + rowId, {
              user_ids: selectedUser.map((user) => user.id),
            })
            .then(() => {
              this.showSuccessMsg('Updated Successfully!');
            });
        }
        this.$nextTick(() => {
          this.isDropdownDisabled = false;
          this.$refs[refKey].deactivate();
        });
      });
    },
    setQueryData(query) {
      this.queryParams = this.withQueryDefaults(defaultQueryParams(), query);
      this.filter = this.withQueryDefaults(defaultFilter(), query);

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };
    },
    resetAll() {
      this.filter = defaultFilter();
      this.queryParams = defaultQueryParams();

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };

      this.selectedGroup = null;
      this.selectedRequestType = null;
      this.selectedUser = null;
      this.selectedStatus = null;
      this.selectedPriority = null;
      this.selectedCompany = null;
      this.selectedContact = null;

      // changeRoute() alone triggers the reload via the '$route.query' watcher.
      this.changeRoute();
    },
    searchQuery() {
      // A new search/filter changes the result set, so the old page number
      // no longer means anything — start from the first page.
      this.queryParams.page = 1;
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/tickets/' + row.id).then(() => {
            this.ticketingEmailTableScroll();
            this.loadData();
            this.$swal.fire('Deleted', 'Ticket has been deleted!', 'success');
          });
        }
      });
    },
    doCombineAction(type) {
      switch (type) {
        case 'delete':
          this.deleteMultipleTickets();
          break;

        default:
          break;
      }
    },
    deleteMultipleTickets() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('delete-multiple-tickets', { ids: this.checkedTickets })
            .then(() => {
              (this.showMultipleAction = false),
                (this.isCheckAll = false),
                (this.checkedTickets = []),
                this.ticketingEmailTableScroll();
              this.loadData();
              this.$swal.fire(
                'Deleted',
                'Ticket/s has been deleted!',
                'success'
              );
            });
        }
      });
    },
    changeRoute() {
      this.$router
        .push({
          name: this.$route.name,
          query: { ...this.queryParams, ...this.filter },
        })
        .then((failure) => {
          // Pushing the identical query is a duplicated navigation, so the
          // '$route.query' watcher never fires — reload explicitly instead.
          if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
            this.loadData();
          }
        });
    },
    onWindowResize() {
      this.ticketingEmailTableScroll();
    },
    // One shared layout for every admin, so this is a plain GET with no user
    // scoping. A failure is not fatal — the catalogue defaults still render.
    loadColumnSettings() {
      this.axios
        .get('/settings/ticket_columns')
        .then(({ data }) => {
          const value = data?.data?.value;

          if (Array.isArray(value)) {
            this.columnConfig = value;
            this.refreshTableLayout();
          }
        })
        .catch(() => {
          // Keep the defaults.
        });
    },
    saveColumnSettings(columns) {
      this.savingColumnSettings = true;
      this.axios
        .post('/settings/ticket_columns', { value: columns })
        .then(({ data }) => {
          this.columnConfig = data?.data?.value ?? columns;
          this.showColumnSettings = false;
          this.refreshTableLayout();
          this.showSuccessMsg('Updated Successfully!');
        })
        .catch((error) => {
          this.$swal.fire(
            'Error',
            error?.response?.data?.message || 'Could not save the columns.',
            'error'
          );
        })
        .finally(() => {
          this.savingColumnSettings = false;
        });
    },
    // ticketingEmailTableScroll() measures the rendered table, so it has to
    // re-run once the new column set is in the DOM.
    refreshTableLayout() {
      this.$nextTick(() => {
        this.ticketingEmailTableScroll();
      });
    },
    loadData() {
      // Drop any in-flight request so a slower earlier response cannot
      // overwrite a newer one.
      if (this.ticketRequestSource) {
        this.ticketRequestSource.cancel('superseded');
      }
      this.ticketRequestSource = rawAxios.CancelToken.source();

      this.lyLoading = true;
      this.axios
        .get('/tickets', {
          params: { ...this.queryParams, ...this.filter },
          cancelToken: this.ticketRequestSource.token,
        })
        .then((response) => {
          this.tickets = response.data.data;
          this.pagination = response.data.meta;
          this.lyLoading = false;
        })
        .catch((error) => {
          if (rawAxios.isCancel(error)) {
            return; // a newer request is running; it owns lyLoading
          }
          this.lyLoading = false;
          throw error;
        });
    },
    onGroupSelect(selected) {
      this.filter.group_id = selected.id;
    },
    onGroupRemove() {
      this.filter.group_id = '';
    },
    onRequestTypeSelect(selected) {
      this.filter.support_request_type_id = selected.id;
    },
    onRequestTypeRemove() {
      this.filter.support_request_type_id = '';
    },
    onUserSelect(selected) {
      this.filter.user_id = selected.id;
    },
    onUserRemove() {
      this.filter.user_id = '';
    },
    onStatusSelect(selected) {
      this.filter.status = selected.label;
    },
    onStatusRemove() {
      this.filter.status = '';
    },
    onPrioritySelect(selected) {
      this.filter.priority = selected.label;
    },
    onPriorityRemove() {
      this.filter.priority = '';
    },
    onCompanySelect(selected) {
      this.filter.company_id = selected.id;
    },
    onCompanyRemove() {
      this.filter.company_id = '';
    },
    onContactSelect(selected) {
      this.filter.contact_id = selected.id;
    },
    onContactRemove() {
      this.filter.contact_id = '';
    },
    async exportTickets() {
      try {
        const response = await this.axios.get('/export-tickets', {
          responseType: 'blob',
        });

        // Create a link to download the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'tickets.csv');
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error('Error exporting tickets:', error);
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.color_green {
  text-decoration: underline;
  color: green;
}
</style>
